/* ==========================================================================
   Carrito lateral (sections/cart-drawer.liquid)
   - Sustituye al popup del tema: intercepta theme.mfpOpen('cart'), así todos
     los botones y "añadir al carrito" existentes abren este carrito.
   - Cantidades, eliminar, notas y códigos de descuento por AJAX
     (/cart/change.js, /cart/update.js) + Section Rendering API.
   ========================================================================== */
(function () {
  'use strict';

  var SECTION = 'cart-drawer';

  function routes() {
    var r = (window.theme && window.theme.routes) || {};
    return {
      root: r.rootUrlSlash || '/',
      change: (r.cartChangeUrl || '/cart/change') + '.js',
      update: (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/update.js'
    };
  }

  var Drawer = {
    el: null,
    lastFocus: null,

    init: function () {
      this.el = document.querySelector('[data-cart-drawer]');
      if (!this.el) return;
      this.panel = this.el.querySelector('.cdr__panel');
      this.bind();
      this.patchTheme();
    },

    /* Todas las aperturas del carrito del tema pasan por theme.mfpOpen('cart') */
    patchTheme: function () {
      var self = this;
      var theme = window.theme;
      if (!theme || typeof theme.mfpOpen !== 'function' || theme.mfpOpen.__cdr) return;
      var original = theme.mfpOpen;
      theme.mfpOpen = function (popup) {
        if (popup === 'cart') {
          self.open();
          return;
        }
        return original.apply(this, arguments);
      };
      theme.mfpOpen.__cdr = true;
    },

    bind: function () {
      var self = this;

      this.el.addEventListener('click', function (e) {
        var close = e.target.closest('[data-cart-drawer-close]');
        if (close) {
          e.preventDefault();
          self.close();
          return;
        }

        var qtyBtn = e.target.closest('[data-cart-qty]');
        if (qtyBtn) {
          var item = qtyBtn.closest('.cdr-item');
          var qty = Math.max(0, parseInt(qtyBtn.getAttribute('data-cart-qty'), 10) || 0);
          // Eliminar (papelera o "−" con cantidad 1) pide confirmación
          if (qty === 0) {
            self.askRemove(item);
          } else {
            self.changeLine(item, qty);
          }
          return;
        }

        if (e.target.closest('[data-cart-confirm-remove]')) {
          var toRemove = e.target.closest('.cdr-item');
          self.cancelRemove(toRemove, false);
          self.changeLine(toRemove, 0);
          return;
        }

        if (e.target.closest('[data-cart-confirm-cancel]')) {
          self.cancelRemove(e.target.closest('.cdr-item'), true);
          return;
        }

        var codeRemove = e.target.closest('[data-cart-code-remove]');
        if (codeRemove) {
          var code = codeRemove.getAttribute('data-cart-code-remove');
          self.setCodes(self.codes().filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); }));
        }
      });

      this.el.addEventListener('input', function (e) {
        if (e.target.matches('[data-cart-coupon-input]')) {
          var btn = self.el.querySelector('[data-cart-coupon-submit]');
          if (btn) btn.disabled = !e.target.value.trim();
          var form = e.target.closest('[data-cart-coupon]');
          if (form) form.classList.remove('is-error');
        }
      });

      this.el.addEventListener('submit', function (e) {
        if (e.target.matches('[data-cart-coupon]')) {
          e.preventDefault();
          self.applyCode();
          return;
        }
        // Checkout: respeta la casilla de términos si existe
        var terms = e.target.querySelector('[data-cart-terms]');
        if (terms && !terms.checked) {
          e.preventDefault();
          terms.focus();
          terms.closest('.cdr-terms').animate(
            [{ transform: 'translateX(-4px)' }, { transform: 'translateX(4px)' }, { transform: 'none' }],
            { duration: 300 }
          );
        }
      });

      this.el.addEventListener('change', function (e) {
        if (e.target.matches('[data-cart-note]')) {
          self.post(routes().update, { note: e.target.value }, false);
        }
      });

      document.addEventListener('keydown', function (e) {
        if (!self.isOpen()) return;
        if (e.key === 'Escape') {
          var confirming = self.el.querySelector('.cdr-item.is-confirming');
          if (confirming) {
            self.cancelRemove(confirming, true);
          } else {
            self.close();
          }
        }
        if (e.key === 'Tab') self.trapFocus(e);
      });

      // Otros componentes pueden pedir abrir/refrescar el carrito
      document.addEventListener('cart:open', function () { self.open(); });
      document.addEventListener('cart:refresh', function () { self.refresh(); });
    },

    isOpen: function () {
      return this.el.classList.contains('is-open');
    },

    open: function () {
      if (!this.el) return;
      var self = this;
      if (!this.isOpen()) {
        this.lastFocus = document.activeElement;
        this.el.removeAttribute('inert');
        this.el.setAttribute('aria-hidden', 'false');
        this.el.classList.add('is-open', 'is-entering');
        document.documentElement.classList.add('cdr-lock');
        setTimeout(function () { self.panel.focus({ preventScroll: true }); }, 50);
        clearTimeout(this.enterTimer);
        this.enterTimer = setTimeout(function () { self.el.classList.remove('is-entering'); }, 1400);
      }
      return this.refresh();
    },

    close: function () {
      if (!this.isOpen()) return;
      this.el.classList.remove('is-open', 'is-entering');
      this.el.setAttribute('aria-hidden', 'true');
      this.el.setAttribute('inert', '');
      document.documentElement.classList.remove('cdr-lock');
      if (this.lastFocus && typeof this.lastFocus.focus === 'function') {
        this.lastFocus.focus({ preventScroll: true });
      }
    },

    trapFocus: function (e) {
      var focusables = Array.prototype.filter.call(
        this.panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), textarea, select, [tabindex]:not([tabindex="-1"])'),
        function (el) { return el.offsetParent !== null; }
      );
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === this.panel)) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    },

    setLoading: function (on) {
      this.el.classList.toggle('is-loading', on);
    },

    /* Pide el HTML de la sección y lo sustituye */
    refresh: function () {
      var self = this;
      this.setLoading(true);
      return fetch(routes().root + '?section_id=' + SECTION, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) { self.render(html); })
        .catch(function () {})
        .then(function () { self.setLoading(false); });
    },

    render: function (html) {
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var next = doc.querySelector('[data-cart-drawer-content]');
      var current = this.el.querySelector('[data-cart-drawer-content]');
      if (!next || !current) return;

      // Conserva lo que el usuario estaba escribiendo en el cupón
      var input = current.querySelector('[data-cart-coupon-input]');
      var typed = input ? input.value : '';
      var hadFocus = input && document.activeElement === input;

      current.replaceWith(next);

      var newInput = next.querySelector('[data-cart-coupon-input]');
      if (newInput && typed) {
        newInput.value = typed;
        var btn = next.querySelector('[data-cart-coupon-submit]');
        if (btn) btn.disabled = false;
        if (hadFocus) newInput.focus();
      }
      this.syncHeader(next);
    },

    /* Contador del icono del carrito en la cabecera */
    syncHeader: function (content) {
      var count = parseInt(content.getAttribute('data-item-count'), 10) || 0;
      document.querySelectorAll('#CartCount, [data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.classList.toggle('hidden-count', count === 0);
      });
    },

    post: function (url, body, render) {
      var self = this;
      if (render !== false) {
        body.sections = SECTION;
        body.sections_url = window.location.pathname;
      }
      this.setLoading(true);
      return fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok || data.status) throw new Error(data.description || data.message || 'Error');
            return data;
          });
        })
        .then(function (data) {
          if (render !== false) {
            // Si la respuesta no trae el HTML de la sección, se pide aparte
            if (data.sections && data.sections[SECTION]) {
              self.render(data.sections[SECTION]);
            } else {
              return self.refresh().then(function () { return data; });
            }
          }
          return data;
        })
        .then(function (data) {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
          if (window.jQuery) window.jQuery(document.body).trigger('afterCartLoad.ajaxCart', data);
          return data;
        })
        .finally(function () { self.setLoading(false); });
    },

    changeLine: function (item, quantity) {
      var self = this;
      if (!item) return;
      var line = parseInt(item.getAttribute('data-line'), 10);
      var run = function () {
        return self.post(routes().change, { line: line, quantity: quantity }).catch(function (err) {
          item.classList.remove('is-updating', 'is-removing');
          window.alert(err.message);
        });
      };
      if (quantity === 0) {
        item.classList.add('is-removing');
        setTimeout(run, 300);
      } else {
        item.classList.add('is-updating');
        run();
      }
    },

    askRemove: function (item) {
      if (!item) return;
      var self = this;
      // Solo una confirmación abierta a la vez
      Array.prototype.forEach.call(this.el.querySelectorAll('.cdr-item.is-confirming'), function (other) {
        if (other !== item) self.cancelRemove(other, false);
      });
      var box = item.querySelector('[data-cart-confirm]');
      if (!box) { this.changeLine(item, 0); return; }
      item.classList.add('is-confirming');
      box.hidden = false;
      var cancel = box.querySelector('[data-cart-confirm-cancel]');
      if (cancel) cancel.focus();
    },

    cancelRemove: function (item, restoreFocus) {
      if (!item) return;
      var box = item.querySelector('[data-cart-confirm]');
      item.classList.remove('is-confirming');
      if (box) box.hidden = true;
      if (restoreFocus) {
        var trash = item.querySelector('.cdr-item__remove');
        if (trash) trash.focus();
      }
    },

    codes: function () {
      var input = this.el.querySelector('[data-cart-coupon-input]');
      var raw = input ? input.getAttribute('data-codes') : '';
      return raw ? raw.split(',').filter(Boolean) : [];
    },

    setCodes: function (codes) {
      return this.post(routes().update, { discount: codes.join(',') });
    },

    applyCode: function () {
      var self = this;
      var input = this.el.querySelector('[data-cart-coupon-input]');
      if (!input) return;
      var code = input.value.trim();
      if (!code) return;

      var existing = this.codes();
      if (existing.some(function (c) { return c.toLowerCase() === code.toLowerCase(); })) {
        input.value = '';
        this.couponMessage('Ese código ya está aplicado.', false);
        return;
      }

      input.value = '';
      this.setCodes(existing.concat(code))
        .then(function (cart) {
          var applied = (cart.discount_codes || []).filter(function (d) {
            return d.code.toLowerCase() === code.toLowerCase();
          })[0];
          if (applied && applied.applicable) {
            self.couponMessage('¡Código ' + applied.code.toUpperCase() + ' aplicado!', false);
          } else {
            self.couponMessage('El código «' + code + '» no es válido o no se puede aplicar a este carrito.', true);
          }
        })
        .catch(function (err) {
          self.couponMessage(err.message, true);
        });
    },

    couponMessage: function (text, isError) {
      var form = this.el.querySelector('[data-cart-coupon]');
      var msg = this.el.querySelector('[data-cart-coupon-message]');
      if (!form || !msg) return;
      form.classList.toggle('is-error', !!isError);
      msg.textContent = text;
      msg.hidden = !text;
    }
  };

  window.EbocaCartDrawer = Drawer;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { Drawer.init(); });
  } else {
    Drawer.init();
  }
})();
